// extracted by mini-css-extract-plugin
module.exports = {"h4":"card_h4__RAvJi"};